import Store from '@/store/index.js'
//数字&阿拉伯数字转换
function chnNumChar(num) {
    let obj = {
        0: '零',
        1: '一',
        2: '二',
        3: '三',
        4: '四',
        5: '五',
        6: '六',
        7: '七',
        8: '八',
        9: '九'
    };
    return obj[num]
}

//数组扁平化处理
function arrayFlat(array, key) {
    if (!array.length || !Array.isArray(array)) {
        return false
    }
    array = JSON.parse(JSON.stringify(array))
    let newArr = []
    array.forEach(item => {
        newArr.push(item)
        if (item[key]) {
            newArr.push.apply(newArr, arrayFlat(item[key],key))
            delete item[key]
        }
    })
    return newArr
}

//获取url参数
function getUrlParam() {
    let temp1 = window.location.href.split('?')
    if(temp1.length !== 2) {
        return {}
    }
    let param = temp1[1]
    let keyValue = param.split('&')
    let obj = {}
    for(let i = 0;i < keyValue.length; i++) {
        let item = keyValue[i].split('=')
        let key = item[0]
        let value = item[1]
        obj[key] = decodeURIComponent(value)
    }
    return obj
}

//新建a标签下载文件
function createTag(url) {
    let a = document.createElement('a')
    a.style.display = 'none'
    a.target = '_blank'
    a.href = url
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    a = null
}

//权限获取
function hasAuth(key) {
    return Store.getters.businessMenuIdList.includes(key)
}

export {
    chnNumChar,
    arrayFlat,
    getUrlParam,
    createTag,
    hasAuth
}